<!-- LoadingRow.svelte -->
<script lang="ts">
  import { cn } from "$lib/utils";
  import type { ColumnDefinition } from "./types";

  let { fixedColumns, dynamicColumns, columnConfigs } = $props<{
    fixedColumns: ColumnDefinition[];
    dynamicColumns: ColumnDefinition[];
    columnConfigs: Record<string, ColumnDefinition>;
  }>();
</script>

<tr class="border-b border-gray-300 dark:border-gray-800">
  <!-- Fixed columns -->
  {#each fixedColumns as column}
    <td
      class="whitespace-nowrap border-r border-theme-text-tertiary bg-inherit"
      style="width: {column.width}px; min-width: {column.minWidth ?? column.width}px;"
    >
      <div class="px-4">
        <div class="h-4 w-4 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
      </div>
    </td>
  {/each}

  <!-- Dynamic columns -->
  {#each dynamicColumns as column}
    <td
      class="border-r border-theme-text-tertiary px-4 py-3"
      style="width: {columnConfigs[column.key].width}px;
            min-width: {columnConfigs[column.key].minWidth ?? columnConfigs[column.key].width}px;"
    >
      {#if column.key === "name"}
        <div class="flex items-center gap-3">
          <div class="h-8 w-8 animate-pulse rounded-full bg-gray-200 dark:bg-gray-500"></div>
          <div class="flex flex-col gap-1">
            <div class="h-4 w-32 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
            <div class="h-3 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
          </div>
        </div>
      {:else if column.key === "criteria"}
        <div class="flex flex-col gap-2">
          <div class="h-4 w-40 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
          <div class="h-4 w-32 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
        </div>
      {:else}
        <div class="h-4 w-32 animate-pulse rounded bg-gray-200 dark:bg-gray-500"></div>
      {/if}
    </td>
  {/each}
</tr>
